import React, { useState } from 'react'
import { Events } from '../Data/Events'
import { Link } from 'react-router-dom'
import { Zoom } from 'react-awesome-reveal'
import { Container, Icon } from 'semantic-ui-react'
import bannerPic1 from '../Pictures/banner1.jpg'

export default function EventsPage() {
  const bannerStyle = {
    backgroundImage: `url(${bannerPic1})`,
  }

  const [filterType, setFilterType] = useState('upcoming') // 'upcoming' | 'past'
  const [selectedYear, setSelectedYear] = useState('all')

  const now = new Date()

  const availableYears = [2026, 2025, 2024, 2023]

  const filteredEvents = [...Events].filter(event => {
    const eventDate = event.sort ? new Date(event.sort) : null
    if (!eventDate) return true

    // Filter by type
    if (filterType === 'upcoming') {
      if (eventDate < now) return false
    } else {
      if (eventDate >= now) return false
    }

    // Filter by year if selected
    if (selectedYear !== 'all') {
      if (eventDate.getFullYear() !== Number(selectedYear)) return false
    }

    return true
  }).sort((a, b) => {
    const dateA = new Date(a.sort || 0)
    const dateB = new Date(b.sort || 0)
    // Upcoming: nearest future first. Past: most recent first.
    return filterType === 'upcoming' ? dateA - dateB : dateB - dateA
  })

  return (
    <div id='eventsPage'>
      {/* Hero Banner */}
      <section className='pageHero' style={bannerStyle}>
        <div className='pageHeroOverlay'></div>
        <div className='pageHeroContent'>
          <Zoom triggerOnce>
            <span className='pageHeroBadge'>Community & Gatherings</span>
            <h1 className='pageHeroHeading'>Events Calendar</h1>
            <div className='goldAccentLine' style={{ margin: '14px auto 20px auto' }}></div>
            <p className='pageHeroSubheading'>
              Celebrate fellowship, participate in seminars, and join cultural and sports activities across the Czech Republic.
            </p>
          </Zoom>
        </div>
      </section>

      {/* Filter Tabs & Content Section */}
      <section className='homeSection'>
        <Container>
          {/* Controls Bar */}
          <div className='eventsControls'>
            <div className='eventsTypeTabs'>
              <button
                className={`eventsTabBtn ${filterType === 'upcoming' ? 'active' : ''}`}
                onClick={() => setFilterType('upcoming')}
              >
                Upcoming Events
              </button>
              <button
                className={`eventsTabBtn ${filterType === 'past' ? 'active' : ''}`}
                onClick={() => setFilterType('past')}
              >
                Past Events
              </button>
            </div>

            <div className='eventsYearFilters'>
              <button
                className={`eventsYearBtn ${selectedYear === 'all' ? 'active' : ''}`}
                onClick={() => setSelectedYear('all')}
              >
                All Years
              </button>
              {availableYears.map(yr => (
                <button
                  key={yr}
                  className={`eventsYearBtn ${selectedYear === String(yr) ? 'active' : ''}`}
                  onClick={() => setSelectedYear(String(yr))}
                >
                  {yr}
                </button>
              ))}
            </div>
          </div>

          {/* Magazine List */}
          <div className='magazineContainer'>
            {filteredEvents.length === 0 ? (
              <div className='homeEmptyState'>
                <h3>
                  {filterType === 'upcoming'
                    ? 'No upcoming events currently scheduled.'
                    : `No past events found for ${selectedYear === 'all' ? 'this selection' : selectedYear}.`}
                </h3>
                <p>
                  {filterType === 'upcoming'
                    ? 'Explore our past events or check back soon for our next gathering!'
                    : 'Try selecting a different year or view all years.'}
                </p>
                {filterType === 'upcoming' ? (
                  <button
                    className='bannerPrimaryBtn'
                    onClick={() => {
                      setFilterType('past')
                      setSelectedYear('all')
                    }}
                  >
                    Browse Past Events
                  </button>
                ) : (
                  <button
                    className='bannerPrimaryBtn'
                    onClick={() => setSelectedYear('all')}
                  >
                    View All Years
                  </button>
                )}
              </div>
            ) : (
              <div className='magazineList'>
                {filteredEvents.map(event => (
                  <article className='magazineItem' key={event.id}>
                    <div className='magazineItemLink'>
                      {event.image && (
                        <Link to={`/eventdetails/${event.id}`} className='magazineImageWrapper'>
                          <img
                            src={event.image}
                            alt={event.event}
                            className='magazineImage'
                            loading='lazy'
                          />
                        </Link>
                      )}
                      <div className='magazineContent'>
                        <div className='magazineMeta'>
                          {event.date && (
                            <span className='homeMetaTag'>
                              <Icon name='calendar alternate outline' /> {event.date}
                            </span>
                          )}
                          {event.time && event.time !== 'TBA' && (
                            <span className='homeMetaTag'>
                              <Icon name='clock outline' /> {event.time}
                            </span>
                          )}
                          {event.location && event.location !== 'TBA' && (
                            <span className='homeMetaTag'>
                              <Icon name='map marker alternate' /> {event.location}
                            </span>
                          )}
                        </div>

                        <Link to={`/eventdetails/${event.id}`}>
                          <h2 className='magazineTitle'>{event.event}</h2>
                        </Link>

                        {event.summary && (
                          <p className='magazineExcerpt'>
                            {typeof event.summary === 'string'
                              ? event.summary
                              : 'Click to view full event schedule and details.'}
                          </p>
                        )}

                        <div className='eventsItemActions'>
                          <Link to={`/eventdetails/${event.id}`} className='magazineActionLink'>
                            Event Details <Icon name='arrow right' />
                          </Link>

                          {event.form && filterType === 'upcoming' && (
                            <a
                              href={event.form}
                              target='_blank'
                              rel='noreferrer'
                              className='eventQuickCta'
                            >
                              Sign Up
                            </a>
                          )}

                          {event.gallery && (
                            <Link
                              to={`/eventgallery/${event.id}`}
                              className='eventGalleryTagLink'
                            >
                              <Icon name='images outline' /> Photos
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </Container>
      </section>
    </div>
  )
}
